import $ from "jquery";
import { isScrollable } from "./isScrollable";

const SCROLL_CONFIG = {
  mobile: {
    block: "start",
    behavior: "smooth"
  },
  modern: {
    offset: 40,
    duration: 500,
    easing: "swing"
  },
  default: {
    offset: 40,
    duration: 500,
    easing: "swing"
  }
};

const MODERN_CONTAINERS = ["div.topicMainContent", "div.webMode"];

/**
 * Scrolls to a target element using different strategies based on view type
 * @param {jQuery} $element - The target element to scroll to
 * @param {boolean} isMobileView - Whether the current view is mobile
 * @param {boolean} isModernView - Whether the current view is modern
 */
export const scrollTo = ($element, isMobileView, isModernView) => {
  if (!$element || !$element.length) {
    console.warn("ScrollTo: Invalid element provided");
    return;
  }

  if (isMobileView) {
    scrollToMobile($element);
  } else if (isModernView) {
    scrollToModern($element);
  } else {
    scrollToDefault($element);
  }
};

/**
 * Handles mobile view scrolling using native scrollIntoView
 * @param {jQuery} $element - The target element
 */
const scrollToMobile = ($element) => {
  const config = SCROLL_CONFIG.mobile;
  $element[0].scrollIntoView({
    block: config.block,
    behavior: config.behavior
  });
};

/**
 * Handles modern view scrolling with container detection
 * @param {jQuery} $element - The target element
 */
const scrollToModern = ($element) => {
  const container = findScrollableContainer();
  if (!container.length) {
    console.warn("ScrollTo: No scrollable container found for modern view");
    scrollToDefault($element);
    return;
  }

  const config = SCROLL_CONFIG.modern;
  const targetPosition = calculateRelativePosition($element, container);

  container.animate({
    scrollTop: targetPosition - config.offset
  }, config.duration, config.easing);
};

/**
 * Handles default view scrolling using html/body animation
 * @param {jQuery} $element - The target element
 */
const scrollToDefault = ($element) => {
  const config = SCROLL_CONFIG.default;
  const elementOffset = $element.offset();

  if (!elementOffset) {
    console.warn("ScrollTo: Could not determine element position");
    return;
  }

  $("html, body").animate({
    scrollTop: elementOffset.top - config.offset
  }, config.duration, config.easing);
};

/**
 * Finds the appropriate scrollable container for modern view
 * @returns {jQuery} The scrollable container
 */
const findScrollableContainer = () => {
  for (const selector of MODERN_CONTAINERS) {
    const $container = $(selector);
    if ($container.length && isScrollable($container)) {
      return $container;
    }
  }
  return $();
};

/**
 * Calculates the relative position of target element within container
 * @param {jQuery} $element - The target element
 * @param {jQuery} $container - The container element
 * @returns {number} The calculated scroll position
 */
const calculateRelativePosition = ($element, $container) => {
  const elementOffset = $element.offset();
  const containerOffset = $container.offset();

  if (!elementOffset || !containerOffset) {
    console.warn("ScrollTo: Could not calculate relative position");
    return 0;
  }

  return elementOffset.top - containerOffset.top + $container.scrollTop();
};